import { useEffect } from 'react'
import { SignedIn, SignedOut, RedirectToSignIn, useClerk } from '@clerk/clerk-react'
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import Layout from './components/Layout'
import InvestigationList from './pages/InvestigationList'
import InvestigationDetail from './pages/InvestigationDetail'
import Settings from './pages/Settings'
import NotificationsSettings from './pages/NotificationsSettings'
import RemediationSettings from './pages/RemediationSettings'
import ForecastSettings from './pages/ForecastSettings'
import NotFound from './pages/NotFound'
import SignInPage from './pages/SignIn'
import Forbidden from './pages/Forbidden'
import './App.css'

function ApiErrorMonitor() {
  const navigate = useNavigate()
  const { signOut } = useClerk()

  useEffect(() => {
    function handler(e: Event) {
      const { status } = (e as CustomEvent<{ status: number }>).detail
      if (status === 401) {
        signOut().then(() => navigate('/sign-in', { replace: true })).catch(() => {
          navigate('/sign-in', { replace: true })
        })
      } else if (status === 403) {
        navigate('/forbidden', { replace: true })
      }
    }
    window.addEventListener('api-auth-error', handler)
    return () => window.removeEventListener('api-auth-error', handler)
  }, [navigate, signOut])

  return null
}

function App() {
  return (
    <BrowserRouter>
      <ApiErrorMonitor />
      <Routes>
        <Route path="/sign-in/*" element={<SignInPage />} />
        <Route path="/forbidden" element={<Forbidden />} />
        <Route
          path="*"
          element={
            <>
              <SignedIn>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Navigate to="/investigations" replace />} />
                    <Route path="/investigations" element={<InvestigationList />} />
                    <Route path="/investigations/:id" element={<InvestigationDetail />} />
                    <Route path="/integrations" element={<Settings />} />
                    <Route path="/settings" element={<Navigate to="/integrations" replace />} />
                    <Route path="/notifications" element={<NotificationsSettings />} />
                    <Route path="/remediation" element={<RemediationSettings />} />
                    <Route path="/forecast" element={<ForecastSettings />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Layout>
              </SignedIn>
              <SignedOut>
                <RedirectToSignIn redirectUrl={window.location.href} />
              </SignedOut>
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
